import React, { Component } from 'react';
import PropTypes from 'prop-types';

class InfoIcon extends Component {
    render() {
        return (
            <div className={this.props.className} style={{ display: 'inline-block' }}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    width="17px"
                    height="17px"
                    viewBox="0 0 17 17"
                >
                    <path fill="#333333" d="M11.1,13H6.7v-1.1h1.1V8.7H6.7V7.6H10v4.3h1.1V13z"/>
                    <circle fill="none" stroke="#333333" strokeMiterlimit="10" cx="8.6" cy="8.6" r="7.9"/>
                    <circle fill="#333333" cx="8.6" cy="5.1" r="1.5"/>
                </svg>
            </div>
        );
    }
}

InfoIcon.propTypes = {
    className: PropTypes.string
};
InfoIcon.defaultProps = {};

export default InfoIcon;
